import { setAllOperations } from 'operations';

export const processAllOperations = ({ dispatch, operations }) => {
  return Promise.resolve()
  .then( () => {
    dispatch(setAllOperations(operations));
    return operations;
  });
};
